import jwt_decode from 'jwt-decode';

export const isTokenExpired = (token) => {
  const decodedToken = jwt_decode(token);
  const currentDate = new Date();

  return decodedToken.exp * 1000 >= currentDate.getTime();
};
